export const LOCATION_ENTITY_ID = 'locations:location'

export const LOCATION_TYPES = [
  'PORT',
  'RAIL_TERMINAL',
  'INTERMODAL',
  'WAREHOUSE',
  'DEPOT',
  'FACTORY',
  'CROSS_DOCK',
  'YARD',
] as const

export const SUPPORTED_MODES = [
  'ROAD',
  'RAIL',
  'SEA',
  'INLAND_WATER',
] as const

export const LOCATION_CAPABILITIES = [
  'CONTAINER',
  'REEFER',
  'ADR',
  'CRANE',
  'RAIL_SIDING',
  'RAMP',
  'COLD_STORAGE',
  'WEIGH_BRIDGE',
  'CUSTOMS',
] as const

export type LocationType = typeof LOCATION_TYPES[number]
export type SupportedMode = typeof SUPPORTED_MODES[number]
export type LocationCapability = typeof LOCATION_CAPABILITIES[number]

export type LocationAddress = {
  street: string
  city: string
  postalCode: string
  country: string
  region?: string | null
}

export type LocationOperatingHours = Record<
  string,
  {
    open?: string | null
    close?: string | null
  }
>

export function uniqueStringArray(values: readonly string[]): string[] {
  return Array.from(new Set(values.map((value) => value.trim()).filter((value) => value.length > 0)))
}
